import { useRouter } from 'next/router';
import { Img } from '../../hybrid/wrappers';
import css from './Wallets.module.scss';
import WalletsItem from './components/WalletsItem.js/WalletsItem';
import { useMemo, useState } from 'react';

export default function Wallets({ wallets, meta, toggleCurr, customCss }) {
    const router = useRouter();
    const isWalletsPage = useMemo(() => router?.route === '/[lang]/wallets', [router?.route]);
    const [radioSwitcher, setRadioSwitcher] = useState(1);
    return (
        <div className={css.wallets}>
            <div className={css.walletBg}></div>
            <div className={css.walletBg2}></div>
            <Img className={css.walletImage} src={'/src/img/office/wallets/wallet_bg.png'} width={300} height={200} />
            {wallets.map((wallet, idx) => (
                <WalletsItem
                    key={wallet.id}
                    wallet={wallet}
                    isLast={!wallets[idx + 1]}
                    setNewFindedCurrency={toggleCurr}
                    index={idx}
                    customCss={customCss}
                    isWalletsPage={isWalletsPage}
                    meta={meta}
                    radioSwitcher={radioSwitcher}
                    setRadioSwitcher={setRadioSwitcher}
                />
            ))}
        </div>
    );
}
